import { render, staticRenderFns } from "./ItemCSVImportInterface.vue?vue&type=template&id=2677bf44"
import script from "./ItemCSVImportInterface.vue?vue&type=script&lang=js"
export * from "./ItemCSVImportInterface.vue?vue&type=script&lang=js"
import style0 from "./ItemCSVImportInterface.vue?vue&type=style&index=0&id=2677bf44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports